module.exports = __webpack_public_path__ + "components/flag/static/square/no-b74d505c3e4bcab1741e71084d92afe7.svg";